import { deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule } from '@fukuri-admins/apis/client/gen/endpoints';

export const deleteStressAssessmentSchedule =
  deleteApiV1ThreeLetterCodeClientAdminsStressCheckSchedule;
